var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "img" }, [
    _c("img", { attrs: { src: _vm.url_hd } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }